import { BackTop, Col, ConfigProvider, Layout, Row, Space } from 'antd';
import { Route } from 'antd/lib/breadcrumb/Breadcrumb';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import AuthorizedContent from '../components/AuthorizedContent';
import SticsHeader from '../components/layoutItems/SticsHeader';
import SticsSider from '../components/layoutItems/SticsSider';
import { FullColumnWidths } from '../config/ColumnWidths';
import InstitutionDTO from '../models/InstitutionDTO';
import { UserSessionActions } from '../redux/actions/UserSessionActions';
import { StateStoreModel } from '../redux/state/StateStoreModel';

interface AuthenticatedLayoutState {
  collapsed: boolean;
}

interface AuthenticatedLayoutProps {
  logoutAction: () => void;
  width?: string;
  breadcrumbs: Route[];
  institution: InstitutionDTO | null;
}

class AuthenticatedLayout extends React.Component<AuthenticatedLayoutProps & RouteComponentProps<Record<string, string | undefined>>, AuthenticatedLayoutState> {
  constructor(props: AuthenticatedLayoutProps & RouteComponentProps<Record<string, string | undefined>>) {
    super(props);

    this.onCollapse = this.onCollapse.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);

    this.state = {
      collapsed: true,
    };
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  toggleMenu() {
    this.setState({ collapsed: !this.state.collapsed });
  }

  onCollapse(collapsed: boolean) {
    this.setState({ collapsed });
  }

  render() {
    return (
      <ConfigProvider componentSize="middle" >
        <Layout style={{ minHeight: '100vh' }}>
          <SticsHeader toggleMenu={this.toggleMenu} collapsed={this.state.collapsed} />
          <Layout>
            <Layout>
              <AuthorizedContent>
                <SticsSider collapseMenu={this.toggleMenu} collapsed={this.state.collapsed} institution={this.props.institution} />
              </AuthorizedContent>
              {this.renderContent()}
            </Layout>
          </Layout>
          <BackTop />
        </Layout>
      </ConfigProvider>
    )
  }

  renderContent(): React.ReactNode {
    let columnProps = {};
    let className = '';

    switch (this.props.width) {
      case 'full':
        columnProps = FullColumnWidths.FULL;
        className = 'width-full';
        break;
      case 'tiny':
        columnProps = FullColumnWidths.TINY;
        className = 'width-tiny';
        break;
      case 'small':
        columnProps = FullColumnWidths.SMALL;
        className = 'width-small';
        break;
      case 'smallish':
        columnProps = FullColumnWidths.SMALLISH;
        className = 'width-small';
        break;
      case 'medium':
        columnProps = FullColumnWidths.MEDIUM;
        className = 'width-medium';
        break;
      case 'extraWide':
        columnProps = FullColumnWidths.EXTRA_WIDE;
        className = 'width-extraWide';
        break;
      case 'extraExtraWide':
        columnProps = FullColumnWidths.EXTRA_EXTRA_WIDE;
        className = 'width-extraWide';
        break;
      case 'wide':
      case 'default':
      default:
        columnProps = FullColumnWidths.WIDE;
        className = 'width-wide';
        break;
    }

    return (
      <Layout>
        <Content>
          <Space direction="vertical" size="small">
            <Row>
              <div id="headerPortal" className="breadcrumb-area" />
            </Row>
            <Row>
              <Col {...columnProps} className={className} >
                {this.props.children}
              </Col>
            </Row>
          </Space>
        </Content>
      </Layout>
    );
  }
}

function mapStateToProps(state: StateStoreModel) {
  return {
    institution: state.Institution.Selected
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    logoutAction: () => dispatch(UserSessionActions.logout()),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthenticatedLayout));
